<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="$t('editProgram.modals.importTargets.textImportTargets')"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ $t('editProgram.modals.importTargets.textDescription') }}
      </p>
      <hr-text-field
        v-model="targetsRaw"
        multiline
        :label="$t('editProgram.modals.importTargets.inputTargetsLabel')"
        :hint="$t('editProgram.modals.importTargets.inputTargetsHint')"
        hide-bottom-space
        class="col-12"
      />
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="onCancelClick"
      />
      <hr-confirm-btn
        :label="$t('editProgram.modals.importTargets.buttonImport')"
        @click="onOKClick"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import { chain, trim } from 'lodash';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'ImportTargets',

  components: {
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
    HrTextField,
  },

  props: {
    // ...your custom props
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      targetsRaw: '',
    };
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      const targets = chain(this.targetsRaw)
        .split('\n')
        .map((target) => trim(target))
        .compact()
        .value();

      this.$emit('ok', targets);
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
</script>
